<div class="requirements-fields-sorting">
  <div class="requirements-fields-sorting__containers">
    <div class="requirements-fields-sorting__outer-container">
      <h4 class="requirements-fields-sorting__title">Available</h4>
      <div class="requirements-fields-sorting__container">
        <procure-card
          #availableList="cdkDropList"
          class="requirements-fields-sorting__list"
          cdkDropList
          condensed
          flat
          [cdkDropListData]="unselected"
          [cdkDropListConnectedTo]="[selectedList]"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of unselected; track item.uuid) {
            <div
              class="requirements-fields-sorting__box"
              cdkDrag
            >
              <div class="requirements-fields-sorting__box-content">
                <mat-icon class="requirements-fields-sorting__available-icon">drag_indicator</mat-icon>
                {{ getTitle(item.name) }}
              </div>
            </div>
          }
        </procure-card>
      </div>
    </div>
    <div class="requirements-fields-sorting__outer-container">
      <h4 class="requirements-fields-sorting__title">Selected</h4>
      <div class="requirements-fields-sorting__container">
        <procure-card
          #selectedList="cdkDropList"
          class="requirements-fields-sorting__list"
          cdkDropList
          condensed
          flat
          [cdkDropListData]="selected"
          [cdkDropListConnectedTo]="[availableList]"
          (cdkDropListDropped)="drop($event, true)"
        >
          @for (item of selected; track item.uuid) {
            <div
              class="requirements-fields-sorting__box"
              cdkDrag
            >
              <div class="requirements-fields-sorting__box-content">
                <mat-icon class="requirements-fields-sorting__selected-icon">check_small</mat-icon>
                {{ getTitle(item.name) }}
              </div>
            </div>
          }
        </procure-card>
      </div>
    </div>
  </div>
</div>
